import { Component, Prop, Vue } from 'vue-property-decorator';
import LockManager from './lock';
import Module from '../api/module';
import Skill from '../api/skill';
import Program from '../api/program';
import Topic from '../api/topic';
import Submodule from '../api/submodule';
import Project from '../api/project';
import Lesson from '../api/lesson';
import Exercise from '../api/exercise';
import { BusEvent } from './bus';

import Dimmer from '@/components/Dimmer.vue';
import Category from '@/api/category';
import Courses from '@/api/course';

@Component({
  components: {
    dimmer: Dimmer
  }
})
export default class CommonVue extends Vue {
  // is this view creating a new entity
  @Prop({ type: Boolean, default: false }) public isNew!: boolean;

  public readonly MODULE_SLUG: string = Module.SLUG;
  public readonly TOPIC_SLUG: string = Topic.SLUG;
  public readonly SKILL_SLUG: string = Skill.SLUG;
  public readonly SUBMODULE_SLUG: string = Submodule.SLUG;
  public readonly LESSON_SLUG: string = Lesson.SLUG;
  public readonly EXERCISE_SLUG: string = Exercise.SLUG;
  public readonly CATEGORY_SLUG: string = Category.SLUG;
  public readonly PROGRAM_SLUG: string = Program.SLUG;
  public readonly PROJECT_SLUG: string = Project.SLUG;
  public readonly COURSES_SLUG: string = Courses.SLUG;

  // media to delete from backend once the entity is saved
  public imagesToDelete: number[] = [];
  public audioToDelete: number[] = [];

  // dimmer variables
  public busy: boolean = false;
  public error: boolean = false;

  // lock management
  public lockManager: LockManager | null = null;

  // flag to avoid entering edit mode when loading the entity
  public ignoreFirstEntityChange: boolean = false;

  public deleteMedia(kind: string, id: number) {
    if (id && kind === 'audio') {
      this.audioToDelete.push(id);
    } else if (id) {
      this.imagesToDelete.push(id);
    }
  }

  public get isDimmed(): boolean {
    return this.busy || this.error;
  }

  public async tryToLock() {
    if (!this.ignoreFirstEntityChange && this.lockManager) {
      if (this.lockManager.isAvailable) {
        try {
          this.releaseLocksBeforeLeaving();
          await this.lockManager.tryAcquireLock();
          return;
        } catch (e) {
          this.$bus.$emit(
            BusEvent.ERROR,
            'Someone else is making changes.',
            new Error(
              'Click refresh to check if they have finished their changes'
            )
          );
          return;
        }
      } else if (this.lockManager.isBusy) {
        this.$bus.$emit(
          BusEvent.ERROR,
          'Someone else is making changes.',
          new Error(
            'Click refresh to check if they have finished their changes'
          )
        );
        return;
      }
    }
  }

  public releaseLocksBeforeLeaving() {
    window.onbeforeunload = () => {
      if (this.lockManager && this.lockManager.isLocked) {
        // noinspection JSIgnoredPromiseFromCall
        this.lockManager.releaseLock();
        this.lockManager = null;
      }
    };

    this.$router.beforeEach((to, from, next) => {
      if (this.lockManager && this.lockManager.isLocked) {
        // noinspection JSIgnoredPromiseFromCall
        this.lockManager.releaseLock();
        this.lockManager = null;
      }
      next();
    });
  }
}
